import clientApi from '@/libs/axios/instance.client';
import type { ApiResponse, QueryParams } from '@/types/common/api.type';
import type { BaseApiClientInterface } from '@/types/service/base-api-client.interface';
import { createSafeApiCall } from '@/utils/safe-api-call';

export class BaseApiClient implements BaseApiClientInterface {
    public safeApiCall;
    protected takeRecords = 10;
    protected endpoints = {};

    constructor() {
        this.safeApiCall = createSafeApiCall(this.constructor.name);
    }

    public getEndpointList() {
        return this.endpoints;
    }

    public getAPIRequestInstance() {
        return clientApi;
    }

    public async fetchApi<T>(url: string, params?: QueryParams) {
        return this.safeApiCall(async () => {
            const res = await this.getAPIRequestInstance().get<ApiResponse<T>>(
                url,
                { params }
            );

            return res.data;
        });
    }

    public async postApi<T>(url: string, payload?: any) {
        return this.safeApiCall(async () => {
            const res = await this.getAPIRequestInstance().post<ApiResponse<T>>(
                url,
                payload
            );

            return res.data;
        });
    }

    public async putApi<T>(url: string, payload?: any) {
        return this.safeApiCall(async () => {
            const res = await this.getAPIRequestInstance().put<ApiResponse<T>>(
                url,
                payload
            );

            return res.data;
        });
    }

    public async destroyApi<T>(
        url: string,
        ids: string[],
        isHardDeleted = false
    ) {
        return this.safeApiCall(async () => {
            const res = await this.getAPIRequestInstance().delete<
                ApiResponse<T>
            >(url, {
                params: { isHardDeleted },
                data: ids,
            });

            return res.data;
        });
    }

    public async fetchBlob(url: string, params?: QueryParams): Promise<Blob> {
        return this.safeApiCall(async () => {
            const res = await this.getAPIRequestInstance().get<Blob>(url, {
                params,
                responseType: 'blob',
            });

            return res.data;
        });
    }
    public buildFormData<T extends Record<string, any>>(
        payload: T
    ): FormData | T {
        const form = new FormData();

        Object.entries(payload).forEach(([key, value]) => {
            if (value !== undefined && value !== null) {
                form.append(
                    key,
                    value instanceof File || value instanceof Blob
                        ? value
                        : String(value)
                );
            }
        });

        return form;
    }
}
